/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedPairResponse,
  PairVolumeResponse,
} from '../models/index';

export interface GetCumulativeVolumeRequest {
    pairBaseAddress: string;
}

export interface GetPairsRequest {
    blockChain: GetPairsBlockChainEnum;
    volumeTimeRange: GetPairsVolumeTimeRangeEnum;
    isReadyToDisplay?: boolean;
    symbol?: string;
    tags?: Array<string>;
    page?: number;
    size?: number;
}

export interface GetVolumeRequest {
    pairBaseAddress: string;
    range: GetVolumeRangeEnum;
    blockChain: GetVolumeBlockChainEnum;
}

/**
 * 
 */
export class PairInfoControllerApi extends runtime.BaseAPI {

    /**
     */
    async getCumulativeVolumeRaw(requestParameters: GetCumulativeVolumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairVolumeResponse>> {
        if (requestParameters['pairBaseAddress'] == null) {
            throw new runtime.RequiredError(
                'pairBaseAddress',
                'Required parameter "pairBaseAddress" was null or undefined when calling getCumulativeVolume().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/pairs/{pairBaseAddress}/cumulative-volume`.replace(`{${"pairBaseAddress"}}`, encodeURIComponent(String(requestParameters['pairBaseAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getCumulativeVolume(requestParameters: GetCumulativeVolumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairVolumeResponse> {
        const response = await this.getCumulativeVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPairsRaw(requestParameters: GetPairsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedPairResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getPairs().'
            );
        }

        if (requestParameters['volumeTimeRange'] == null) {
            throw new runtime.RequiredError(
                'volumeTimeRange',
                'Required parameter "volumeTimeRange" was null or undefined when calling getPairs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['isReadyToDisplay'] != null) {
            queryParameters['is_ready_to_display'] = requestParameters['isReadyToDisplay'];
        }

        if (requestParameters['symbol'] != null) {
            queryParameters['symbol'] = requestParameters['symbol'];
        }

        if (requestParameters['volumeTimeRange'] != null) {
            queryParameters['volume_time_range'] = requestParameters['volumeTimeRange'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/pairs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPairs(requestParameters: GetPairsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedPairResponse> {
        const response = await this.getPairsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVolumeRaw(requestParameters: GetVolumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairVolumeResponse>> {
        if (requestParameters['pairBaseAddress'] == null) {
            throw new runtime.RequiredError(
                'pairBaseAddress',
                'Required parameter "pairBaseAddress" was null or undefined when calling getVolume().'
            );
        }

        if (requestParameters['range'] == null) {
            throw new runtime.RequiredError(
                'range',
                'Required parameter "range" was null or undefined when calling getVolume().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getVolume().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['range'] != null) {
            queryParameters['range'] = requestParameters['range'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/pairs/{pairBaseAddress}/volume`.replace(`{${"pairBaseAddress"}}`, encodeURIComponent(String(requestParameters['pairBaseAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVolume(requestParameters: GetVolumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairVolumeResponse> {
        const response = await this.getVolumeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetPairsBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPairsVolumeTimeRangeEnum {
    OneDay = 'ONE_DAY',
    SevenDay = 'SEVEN_DAY',
    ThirtyDay = 'THIRTY_DAY',
    All = 'ALL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetVolumeRangeEnum {
    OneDay = 'ONE_DAY',
    SevenDay = 'SEVEN_DAY',
    ThirtyDay = 'THIRTY_DAY',
    All = 'ALL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetVolumeBlockChainEnum {
    Monad = 'MONAD'
}
